import React from "react";
import LoaderSpinner from "../LoaderSpinner";

const ConfirmModal = ({ message, onConfirm, onCancel, loading }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg text-center max-w-[400px] w-full">
        <div className="flex justify-center items-center mb-4">
          <div className="flex justify-center items-center w-16 h-16 rounded-full bg-blue-100">
            <svg
              className="w-8 h-8 text-blue-600"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v4a1 1 0 102 0V7zm-1 6a1 1 0 100 2 1 1 0 000-2z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>

        {loading ? (
          <>
            <h2 className="text-2xl font-semibold text-gray-800">
              Please Wait
            </h2>
            <LoaderSpinner style="no" />
          </>
        ) : (
          <>
            <h2 className="text-2xl font-semibold text-gray-800">
              Confirm Action
            </h2>
            <p className="mt-2 text-gray-600">{message}</p>
            <div className="mt-4 flex justify-around space-x-4">
              <button
                type="button"
                onClick={onConfirm}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
              >
                Yes
              </button>
              <button
                type="button"
                onClick={onCancel}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                No
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmModal;
